import Vue from 'vue'
import {
  Button, Form, FormItem, Input, Select, Option, Message, Container, Header, Aside,
  Menu, MenuItem, Submenu, Main, Footer, Tooltip, Dropdown, DropdownItem,
  DropdownMenu, Collapse, CollapseItem, Tabs, TabPane, Pagination, Table, TableColumn,
  ButtonGroup, Row, Col, Switch, RadioGroup, RadioButton, CheckboxGroup, CheckboxButton,
  Loading, Checkbox, DatePicker, Notification, MessageBox, Tree, Dialog, Carousel, CarouselItem,
  Drawer, Divider, Card, InputNumber, Radio, Link, Progress, Popover, Transfer, Tag, Upload, Image,
  Breadcrumb, BreadcrumbItem, Badge, Autocomplete, Step, Steps, Timeline, TimelineItem, TimePicker,
  Cascader, Calendar, ColorPicker, Statistic, Descriptions, DescriptionsItem
} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Tooltip)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Pagination)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(ButtonGroup)
Vue.use(Row)
Vue.use(Col)
Vue.use(Switch)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Radio)
Vue.use(Link)
Vue.use(CheckboxGroup)
Vue.use(CheckboxButton)
Vue.use(Loading)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Tree)
Vue.use(Dialog)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Drawer)
Vue.use(Divider)
Vue.use(Card)
Vue.use(InputNumber)
Vue.use(Progress)
Vue.use(Popover)
Vue.use(Transfer)
Vue.use(Tag)
Vue.use(Upload)
Vue.use(Image)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Badge)
Vue.use(Autocomplete)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(TimePicker)
Vue.use(Cascader)
Vue.use(Calendar)
Vue.use(ColorPicker)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Statistic)

Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
